// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type GetTagsQueryVariables = PrivateSchemaTypes.Exact<{ [key: string]: never; }>;


export type GetTagsQuery = (
  { __typename?: 'Query' }
  & { tags?: PrivateSchemaTypes.Maybe<Array<(
    { __typename?: 'TagModel' }
    & Pick<PrivateSchemaTypes.TagModel, 'id' | 'name'>
  )>> }
);

export type CreateTagMutationVariables = PrivateSchemaTypes.Exact<{
  name: PrivateSchemaTypes.Scalars['String'];
}>;


export type CreateTagMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { createTag?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TagModel' }
      & Pick<PrivateSchemaTypes.TagModel, 'id' | 'name'>
    )> }
  )> }
);

export type AddTagToEventMutationVariables = PrivateSchemaTypes.Exact<{
  entityId: PrivateSchemaTypes.Scalars['PositiveInt'];
  tagId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type AddTagToEventMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { event?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'EventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'id' | 'addTag'>
    )> }
  )> }
);

export type RemoveTagFromEventMutationVariables = PrivateSchemaTypes.Exact<{
  entityId: PrivateSchemaTypes.Scalars['PositiveInt'];
  tagId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type RemoveTagFromEventMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { event?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'EventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'id' | 'removeTag'>
    )> }
  )> }
);

export type RemoveAllTagsFromEventMutationVariables = PrivateSchemaTypes.Exact<{
  entityId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type RemoveAllTagsFromEventMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { event?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'EventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'id' | 'removeAllTags'>
    )> }
  )> }
);

export type AddTagToPathwayMutationVariables = PrivateSchemaTypes.Exact<{
  entityId: PrivateSchemaTypes.Scalars['PositiveInt'];
  tagId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type AddTagToPathwayMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { pathway?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'PathwayModelAsAdmin' }
      & Pick<PrivateSchemaTypes.PathwayModelAsAdmin, 'id' | 'addTag'>
    )> }
  )> }
);

export type RemoveTagFromPathwayMutationVariables = PrivateSchemaTypes.Exact<{
  entityId: PrivateSchemaTypes.Scalars['PositiveInt'];
  tagId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type RemoveTagFromPathwayMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { pathway?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'PathwayModelAsAdmin' }
      & Pick<PrivateSchemaTypes.PathwayModelAsAdmin, 'id' | 'removeTag'>
    )> }
  )> }
);

export type RemoveAllTagsFromPathwayMutationVariables = PrivateSchemaTypes.Exact<{
  entityId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type RemoveAllTagsFromPathwayMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { pathway?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'PathwayModelAsAdmin' }
      & Pick<PrivateSchemaTypes.PathwayModelAsAdmin, 'id' | 'removeAllTags'>
    )> }
  )> }
);

export type AddTagToSurveyMutationVariables = PrivateSchemaTypes.Exact<{
  entityId: PrivateSchemaTypes.Scalars['PositiveInt'];
  tagId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type AddTagToSurveyMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { survey?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'SurveyModelAsAdmin' }
      & Pick<PrivateSchemaTypes.SurveyModelAsAdmin, 'id' | 'addTag'>
    )> }
  )> }
);

export type RemoveTagFromSurveyMutationVariables = PrivateSchemaTypes.Exact<{
  entityId: PrivateSchemaTypes.Scalars['PositiveInt'];
  tagId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type RemoveTagFromSurveyMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { survey?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'SurveyModelAsAdmin' }
      & Pick<PrivateSchemaTypes.SurveyModelAsAdmin, 'id' | 'removeTag'>
    )> }
  )> }
);

export type RemoveAllTagsFromSurveyMutationVariables = PrivateSchemaTypes.Exact<{
  entityId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type RemoveAllTagsFromSurveyMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { survey?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'SurveyModelAsAdmin' }
      & Pick<PrivateSchemaTypes.SurveyModelAsAdmin, 'id' | 'removeAllTags'>
    )> }
  )> }
);

export type AddTagToRecurringEventMutationVariables = PrivateSchemaTypes.Exact<{
  entityId: PrivateSchemaTypes.Scalars['PositiveInt'];
  tagId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type AddTagToRecurringEventMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { recurringEvent?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'RecurringEventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.RecurringEventModelAsAdmin, 'id' | 'addTag'>
    )> }
  )> }
);

export type RemoveTagFromRecurringEventMutationVariables = PrivateSchemaTypes.Exact<{
  entityId: PrivateSchemaTypes.Scalars['PositiveInt'];
  tagId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type RemoveTagFromRecurringEventMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { recurringEvent?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'RecurringEventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.RecurringEventModelAsAdmin, 'id' | 'removeTag'>
    )> }
  )> }
);

export type RemoveAllTagsFromRecurringEventMutationVariables = PrivateSchemaTypes.Exact<{
  entityId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type RemoveAllTagsFromRecurringEventMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { recurringEvent?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'RecurringEventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.RecurringEventModelAsAdmin, 'id' | 'removeAllTags'>
    )> }
  )> }
);

export type AddTagToWorkspaceMutationVariables = PrivateSchemaTypes.Exact<{
  entityId: PrivateSchemaTypes.Scalars['PositiveInt'];
  tagId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type AddTagToWorkspaceMutation = (
  { __typename?: 'Mutation' }
  & { workspace?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'WorkspaceModelAsCollaborator' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsCollaborator, 'id'>
  ) | (
    { __typename?: 'WorkspaceModelAsCoordinator' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsCoordinator, 'addTag' | 'id'>
  ) | (
    { __typename?: 'WorkspaceModelAsMember' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsMember, 'id'>
  )> }
);

export type RemoveTagFromWorkspaceMutationVariables = PrivateSchemaTypes.Exact<{
  entityId: PrivateSchemaTypes.Scalars['PositiveInt'];
  tagId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type RemoveTagFromWorkspaceMutation = (
  { __typename?: 'Mutation' }
  & { workspace?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'WorkspaceModelAsCollaborator' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsCollaborator, 'id'>
  ) | (
    { __typename?: 'WorkspaceModelAsCoordinator' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsCoordinator, 'removeTag' | 'id'>
  ) | (
    { __typename?: 'WorkspaceModelAsMember' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsMember, 'id'>
  )> }
);

export type RemoveAllTagsFromWorkspaceMutationVariables = PrivateSchemaTypes.Exact<{
  entityId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type RemoveAllTagsFromWorkspaceMutation = (
  { __typename?: 'Mutation' }
  & { workspace?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'WorkspaceModelAsCollaborator' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsCollaborator, 'id'>
  ) | (
    { __typename?: 'WorkspaceModelAsCoordinator' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsCoordinator, 'removeAllTags' | 'id'>
  ) | (
    { __typename?: 'WorkspaceModelAsMember' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsMember, 'id'>
  )> }
);


export const GetTagsDocument = gql`
    query getTags {
  tags {
    id
    name
  }
}
    `;

/**
 * __useGetTagsQuery__
 *
 * To run a query within a React component, call `useGetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTagsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
      }
export function useGetTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
        }
export type GetTagsQueryHookResult = ReturnType<typeof useGetTagsQuery>;
export type GetTagsLazyQueryHookResult = ReturnType<typeof useGetTagsLazyQuery>;
export type GetTagsQueryResult = Apollo.QueryResult<GetTagsQuery, GetTagsQueryVariables>;
export const CreateTagDocument = gql`
    mutation createTag($name: String!) {
  admin {
    createTag(name: $name) {
      id
      name
    }
  }
}
    `;
export type CreateTagMutationFn = Apollo.MutationFunction<CreateTagMutation, CreateTagMutationVariables>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateTagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTagMutation, CreateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateTagMutation, CreateTagMutationVariables>(CreateTagDocument, options);
      }
export type CreateTagMutationHookResult = ReturnType<typeof useCreateTagMutation>;
export type CreateTagMutationResult = Apollo.MutationResult<CreateTagMutation>;
export type CreateTagMutationOptions = Apollo.BaseMutationOptions<CreateTagMutation, CreateTagMutationVariables>;
export const AddTagToEventDocument = gql`
    mutation addTagToEvent($entityId: PositiveInt!, $tagId: PositiveInt!) {
  admin {
    event(id: $entityId) {
      id
      addTag(id: $tagId)
    }
  }
}
    `;
export type AddTagToEventMutationFn = Apollo.MutationFunction<AddTagToEventMutation, AddTagToEventMutationVariables>;

/**
 * __useAddTagToEventMutation__
 *
 * To run a mutation, you first call `useAddTagToEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTagToEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTagToEventMutation, { data, loading, error }] = useAddTagToEventMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useAddTagToEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddTagToEventMutation, AddTagToEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddTagToEventMutation, AddTagToEventMutationVariables>(AddTagToEventDocument, options);
      }
export type AddTagToEventMutationHookResult = ReturnType<typeof useAddTagToEventMutation>;
export type AddTagToEventMutationResult = Apollo.MutationResult<AddTagToEventMutation>;
export type AddTagToEventMutationOptions = Apollo.BaseMutationOptions<AddTagToEventMutation, AddTagToEventMutationVariables>;
export const RemoveTagFromEventDocument = gql`
    mutation removeTagFromEvent($entityId: PositiveInt!, $tagId: PositiveInt!) {
  admin {
    event(id: $entityId) {
      id
      removeTag(id: $tagId)
    }
  }
}
    `;
export type RemoveTagFromEventMutationFn = Apollo.MutationFunction<RemoveTagFromEventMutation, RemoveTagFromEventMutationVariables>;

/**
 * __useRemoveTagFromEventMutation__
 *
 * To run a mutation, you first call `useRemoveTagFromEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTagFromEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTagFromEventMutation, { data, loading, error }] = useRemoveTagFromEventMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useRemoveTagFromEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveTagFromEventMutation, RemoveTagFromEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveTagFromEventMutation, RemoveTagFromEventMutationVariables>(RemoveTagFromEventDocument, options);
      }
export type RemoveTagFromEventMutationHookResult = ReturnType<typeof useRemoveTagFromEventMutation>;
export type RemoveTagFromEventMutationResult = Apollo.MutationResult<RemoveTagFromEventMutation>;
export type RemoveTagFromEventMutationOptions = Apollo.BaseMutationOptions<RemoveTagFromEventMutation, RemoveTagFromEventMutationVariables>;
export const RemoveAllTagsFromEventDocument = gql`
    mutation removeAllTagsFromEvent($entityId: PositiveInt!) {
  admin {
    event(id: $entityId) {
      id
      removeAllTags
    }
  }
}
    `;
export type RemoveAllTagsFromEventMutationFn = Apollo.MutationFunction<RemoveAllTagsFromEventMutation, RemoveAllTagsFromEventMutationVariables>;

/**
 * __useRemoveAllTagsFromEventMutation__
 *
 * To run a mutation, you first call `useRemoveAllTagsFromEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAllTagsFromEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAllTagsFromEventMutation, { data, loading, error }] = useRemoveAllTagsFromEventMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useRemoveAllTagsFromEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveAllTagsFromEventMutation, RemoveAllTagsFromEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveAllTagsFromEventMutation, RemoveAllTagsFromEventMutationVariables>(RemoveAllTagsFromEventDocument, options);
      }
export type RemoveAllTagsFromEventMutationHookResult = ReturnType<typeof useRemoveAllTagsFromEventMutation>;
export type RemoveAllTagsFromEventMutationResult = Apollo.MutationResult<RemoveAllTagsFromEventMutation>;
export type RemoveAllTagsFromEventMutationOptions = Apollo.BaseMutationOptions<RemoveAllTagsFromEventMutation, RemoveAllTagsFromEventMutationVariables>;
export const AddTagToPathwayDocument = gql`
    mutation addTagToPathway($entityId: PositiveInt!, $tagId: PositiveInt!) {
  admin {
    pathway(id: $entityId) {
      id
      addTag(id: $tagId)
    }
  }
}
    `;
export type AddTagToPathwayMutationFn = Apollo.MutationFunction<AddTagToPathwayMutation, AddTagToPathwayMutationVariables>;

/**
 * __useAddTagToPathwayMutation__
 *
 * To run a mutation, you first call `useAddTagToPathwayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTagToPathwayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTagToPathwayMutation, { data, loading, error }] = useAddTagToPathwayMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useAddTagToPathwayMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddTagToPathwayMutation, AddTagToPathwayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddTagToPathwayMutation, AddTagToPathwayMutationVariables>(AddTagToPathwayDocument, options);
      }
export type AddTagToPathwayMutationHookResult = ReturnType<typeof useAddTagToPathwayMutation>;
export type AddTagToPathwayMutationResult = Apollo.MutationResult<AddTagToPathwayMutation>;
export type AddTagToPathwayMutationOptions = Apollo.BaseMutationOptions<AddTagToPathwayMutation, AddTagToPathwayMutationVariables>;
export const RemoveTagFromPathwayDocument = gql`
    mutation removeTagFromPathway($entityId: PositiveInt!, $tagId: PositiveInt!) {
  admin {
    pathway(id: $entityId) {
      id
      removeTag(id: $tagId)
    }
  }
}
    `;
export type RemoveTagFromPathwayMutationFn = Apollo.MutationFunction<RemoveTagFromPathwayMutation, RemoveTagFromPathwayMutationVariables>;

/**
 * __useRemoveTagFromPathwayMutation__
 *
 * To run a mutation, you first call `useRemoveTagFromPathwayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTagFromPathwayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTagFromPathwayMutation, { data, loading, error }] = useRemoveTagFromPathwayMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useRemoveTagFromPathwayMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveTagFromPathwayMutation, RemoveTagFromPathwayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveTagFromPathwayMutation, RemoveTagFromPathwayMutationVariables>(RemoveTagFromPathwayDocument, options);
      }
export type RemoveTagFromPathwayMutationHookResult = ReturnType<typeof useRemoveTagFromPathwayMutation>;
export type RemoveTagFromPathwayMutationResult = Apollo.MutationResult<RemoveTagFromPathwayMutation>;
export type RemoveTagFromPathwayMutationOptions = Apollo.BaseMutationOptions<RemoveTagFromPathwayMutation, RemoveTagFromPathwayMutationVariables>;
export const RemoveAllTagsFromPathwayDocument = gql`
    mutation removeAllTagsFromPathway($entityId: PositiveInt!) {
  admin {
    pathway(id: $entityId) {
      id
      removeAllTags
    }
  }
}
    `;
export type RemoveAllTagsFromPathwayMutationFn = Apollo.MutationFunction<RemoveAllTagsFromPathwayMutation, RemoveAllTagsFromPathwayMutationVariables>;

/**
 * __useRemoveAllTagsFromPathwayMutation__
 *
 * To run a mutation, you first call `useRemoveAllTagsFromPathwayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAllTagsFromPathwayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAllTagsFromPathwayMutation, { data, loading, error }] = useRemoveAllTagsFromPathwayMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useRemoveAllTagsFromPathwayMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveAllTagsFromPathwayMutation, RemoveAllTagsFromPathwayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveAllTagsFromPathwayMutation, RemoveAllTagsFromPathwayMutationVariables>(RemoveAllTagsFromPathwayDocument, options);
      }
export type RemoveAllTagsFromPathwayMutationHookResult = ReturnType<typeof useRemoveAllTagsFromPathwayMutation>;
export type RemoveAllTagsFromPathwayMutationResult = Apollo.MutationResult<RemoveAllTagsFromPathwayMutation>;
export type RemoveAllTagsFromPathwayMutationOptions = Apollo.BaseMutationOptions<RemoveAllTagsFromPathwayMutation, RemoveAllTagsFromPathwayMutationVariables>;
export const AddTagToSurveyDocument = gql`
    mutation addTagToSurvey($entityId: PositiveInt!, $tagId: PositiveInt!) {
  admin {
    survey(id: $entityId) {
      id
      addTag(id: $tagId)
    }
  }
}
    `;
export type AddTagToSurveyMutationFn = Apollo.MutationFunction<AddTagToSurveyMutation, AddTagToSurveyMutationVariables>;

/**
 * __useAddTagToSurveyMutation__
 *
 * To run a mutation, you first call `useAddTagToSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTagToSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTagToSurveyMutation, { data, loading, error }] = useAddTagToSurveyMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useAddTagToSurveyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddTagToSurveyMutation, AddTagToSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddTagToSurveyMutation, AddTagToSurveyMutationVariables>(AddTagToSurveyDocument, options);
      }
export type AddTagToSurveyMutationHookResult = ReturnType<typeof useAddTagToSurveyMutation>;
export type AddTagToSurveyMutationResult = Apollo.MutationResult<AddTagToSurveyMutation>;
export type AddTagToSurveyMutationOptions = Apollo.BaseMutationOptions<AddTagToSurveyMutation, AddTagToSurveyMutationVariables>;
export const RemoveTagFromSurveyDocument = gql`
    mutation removeTagFromSurvey($entityId: PositiveInt!, $tagId: PositiveInt!) {
  admin {
    survey(id: $entityId) {
      id
      removeTag(id: $tagId)
    }
  }
}
    `;
export type RemoveTagFromSurveyMutationFn = Apollo.MutationFunction<RemoveTagFromSurveyMutation, RemoveTagFromSurveyMutationVariables>;

/**
 * __useRemoveTagFromSurveyMutation__
 *
 * To run a mutation, you first call `useRemoveTagFromSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTagFromSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTagFromSurveyMutation, { data, loading, error }] = useRemoveTagFromSurveyMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useRemoveTagFromSurveyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveTagFromSurveyMutation, RemoveTagFromSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveTagFromSurveyMutation, RemoveTagFromSurveyMutationVariables>(RemoveTagFromSurveyDocument, options);
      }
export type RemoveTagFromSurveyMutationHookResult = ReturnType<typeof useRemoveTagFromSurveyMutation>;
export type RemoveTagFromSurveyMutationResult = Apollo.MutationResult<RemoveTagFromSurveyMutation>;
export type RemoveTagFromSurveyMutationOptions = Apollo.BaseMutationOptions<RemoveTagFromSurveyMutation, RemoveTagFromSurveyMutationVariables>;
export const RemoveAllTagsFromSurveyDocument = gql`
    mutation removeAllTagsFromSurvey($entityId: PositiveInt!) {
  admin {
    survey(id: $entityId) {
      id
      removeAllTags
    }
  }
}
    `;
export type RemoveAllTagsFromSurveyMutationFn = Apollo.MutationFunction<RemoveAllTagsFromSurveyMutation, RemoveAllTagsFromSurveyMutationVariables>;

/**
 * __useRemoveAllTagsFromSurveyMutation__
 *
 * To run a mutation, you first call `useRemoveAllTagsFromSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAllTagsFromSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAllTagsFromSurveyMutation, { data, loading, error }] = useRemoveAllTagsFromSurveyMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useRemoveAllTagsFromSurveyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveAllTagsFromSurveyMutation, RemoveAllTagsFromSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveAllTagsFromSurveyMutation, RemoveAllTagsFromSurveyMutationVariables>(RemoveAllTagsFromSurveyDocument, options);
      }
export type RemoveAllTagsFromSurveyMutationHookResult = ReturnType<typeof useRemoveAllTagsFromSurveyMutation>;
export type RemoveAllTagsFromSurveyMutationResult = Apollo.MutationResult<RemoveAllTagsFromSurveyMutation>;
export type RemoveAllTagsFromSurveyMutationOptions = Apollo.BaseMutationOptions<RemoveAllTagsFromSurveyMutation, RemoveAllTagsFromSurveyMutationVariables>;
export const AddTagToRecurringEventDocument = gql`
    mutation addTagToRecurringEvent($entityId: PositiveInt!, $tagId: PositiveInt!) {
  admin {
    recurringEvent(id: $entityId) {
      id
      addTag(id: $tagId)
    }
  }
}
    `;
export type AddTagToRecurringEventMutationFn = Apollo.MutationFunction<AddTagToRecurringEventMutation, AddTagToRecurringEventMutationVariables>;

/**
 * __useAddTagToRecurringEventMutation__
 *
 * To run a mutation, you first call `useAddTagToRecurringEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTagToRecurringEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTagToRecurringEventMutation, { data, loading, error }] = useAddTagToRecurringEventMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useAddTagToRecurringEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddTagToRecurringEventMutation, AddTagToRecurringEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddTagToRecurringEventMutation, AddTagToRecurringEventMutationVariables>(AddTagToRecurringEventDocument, options);
      }
export type AddTagToRecurringEventMutationHookResult = ReturnType<typeof useAddTagToRecurringEventMutation>;
export type AddTagToRecurringEventMutationResult = Apollo.MutationResult<AddTagToRecurringEventMutation>;
export type AddTagToRecurringEventMutationOptions = Apollo.BaseMutationOptions<AddTagToRecurringEventMutation, AddTagToRecurringEventMutationVariables>;
export const RemoveTagFromRecurringEventDocument = gql`
    mutation removeTagFromRecurringEvent($entityId: PositiveInt!, $tagId: PositiveInt!) {
  admin {
    recurringEvent(id: $entityId) {
      id
      removeTag(id: $tagId)
    }
  }
}
    `;
export type RemoveTagFromRecurringEventMutationFn = Apollo.MutationFunction<RemoveTagFromRecurringEventMutation, RemoveTagFromRecurringEventMutationVariables>;

/**
 * __useRemoveTagFromRecurringEventMutation__
 *
 * To run a mutation, you first call `useRemoveTagFromRecurringEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTagFromRecurringEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTagFromRecurringEventMutation, { data, loading, error }] = useRemoveTagFromRecurringEventMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useRemoveTagFromRecurringEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveTagFromRecurringEventMutation, RemoveTagFromRecurringEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveTagFromRecurringEventMutation, RemoveTagFromRecurringEventMutationVariables>(RemoveTagFromRecurringEventDocument, options);
      }
export type RemoveTagFromRecurringEventMutationHookResult = ReturnType<typeof useRemoveTagFromRecurringEventMutation>;
export type RemoveTagFromRecurringEventMutationResult = Apollo.MutationResult<RemoveTagFromRecurringEventMutation>;
export type RemoveTagFromRecurringEventMutationOptions = Apollo.BaseMutationOptions<RemoveTagFromRecurringEventMutation, RemoveTagFromRecurringEventMutationVariables>;
export const RemoveAllTagsFromRecurringEventDocument = gql`
    mutation removeAllTagsFromRecurringEvent($entityId: PositiveInt!) {
  admin {
    recurringEvent(id: $entityId) {
      id
      removeAllTags
    }
  }
}
    `;
export type RemoveAllTagsFromRecurringEventMutationFn = Apollo.MutationFunction<RemoveAllTagsFromRecurringEventMutation, RemoveAllTagsFromRecurringEventMutationVariables>;

/**
 * __useRemoveAllTagsFromRecurringEventMutation__
 *
 * To run a mutation, you first call `useRemoveAllTagsFromRecurringEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAllTagsFromRecurringEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAllTagsFromRecurringEventMutation, { data, loading, error }] = useRemoveAllTagsFromRecurringEventMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useRemoveAllTagsFromRecurringEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveAllTagsFromRecurringEventMutation, RemoveAllTagsFromRecurringEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveAllTagsFromRecurringEventMutation, RemoveAllTagsFromRecurringEventMutationVariables>(RemoveAllTagsFromRecurringEventDocument, options);
      }
export type RemoveAllTagsFromRecurringEventMutationHookResult = ReturnType<typeof useRemoveAllTagsFromRecurringEventMutation>;
export type RemoveAllTagsFromRecurringEventMutationResult = Apollo.MutationResult<RemoveAllTagsFromRecurringEventMutation>;
export type RemoveAllTagsFromRecurringEventMutationOptions = Apollo.BaseMutationOptions<RemoveAllTagsFromRecurringEventMutation, RemoveAllTagsFromRecurringEventMutationVariables>;
export const AddTagToWorkspaceDocument = gql`
    mutation addTagToWorkspace($entityId: PositiveInt!, $tagId: PositiveInt!) {
  workspace(id: $entityId) {
    id
    ... on WorkspaceModelAsCoordinator {
      addTag(id: $tagId)
    }
  }
}
    `;
export type AddTagToWorkspaceMutationFn = Apollo.MutationFunction<AddTagToWorkspaceMutation, AddTagToWorkspaceMutationVariables>;

/**
 * __useAddTagToWorkspaceMutation__
 *
 * To run a mutation, you first call `useAddTagToWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTagToWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTagToWorkspaceMutation, { data, loading, error }] = useAddTagToWorkspaceMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useAddTagToWorkspaceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddTagToWorkspaceMutation, AddTagToWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddTagToWorkspaceMutation, AddTagToWorkspaceMutationVariables>(AddTagToWorkspaceDocument, options);
      }
export type AddTagToWorkspaceMutationHookResult = ReturnType<typeof useAddTagToWorkspaceMutation>;
export type AddTagToWorkspaceMutationResult = Apollo.MutationResult<AddTagToWorkspaceMutation>;
export type AddTagToWorkspaceMutationOptions = Apollo.BaseMutationOptions<AddTagToWorkspaceMutation, AddTagToWorkspaceMutationVariables>;
export const RemoveTagFromWorkspaceDocument = gql`
    mutation removeTagFromWorkspace($entityId: PositiveInt!, $tagId: PositiveInt!) {
  workspace(id: $entityId) {
    id
    ... on WorkspaceModelAsCoordinator {
      removeTag(id: $tagId)
    }
  }
}
    `;
export type RemoveTagFromWorkspaceMutationFn = Apollo.MutationFunction<RemoveTagFromWorkspaceMutation, RemoveTagFromWorkspaceMutationVariables>;

/**
 * __useRemoveTagFromWorkspaceMutation__
 *
 * To run a mutation, you first call `useRemoveTagFromWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTagFromWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTagFromWorkspaceMutation, { data, loading, error }] = useRemoveTagFromWorkspaceMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useRemoveTagFromWorkspaceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveTagFromWorkspaceMutation, RemoveTagFromWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveTagFromWorkspaceMutation, RemoveTagFromWorkspaceMutationVariables>(RemoveTagFromWorkspaceDocument, options);
      }
export type RemoveTagFromWorkspaceMutationHookResult = ReturnType<typeof useRemoveTagFromWorkspaceMutation>;
export type RemoveTagFromWorkspaceMutationResult = Apollo.MutationResult<RemoveTagFromWorkspaceMutation>;
export type RemoveTagFromWorkspaceMutationOptions = Apollo.BaseMutationOptions<RemoveTagFromWorkspaceMutation, RemoveTagFromWorkspaceMutationVariables>;
export const RemoveAllTagsFromWorkspaceDocument = gql`
    mutation removeAllTagsFromWorkspace($entityId: PositiveInt!) {
  workspace(id: $entityId) {
    id
    ... on WorkspaceModelAsCoordinator {
      removeAllTags
    }
  }
}
    `;
export type RemoveAllTagsFromWorkspaceMutationFn = Apollo.MutationFunction<RemoveAllTagsFromWorkspaceMutation, RemoveAllTagsFromWorkspaceMutationVariables>;

/**
 * __useRemoveAllTagsFromWorkspaceMutation__
 *
 * To run a mutation, you first call `useRemoveAllTagsFromWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAllTagsFromWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAllTagsFromWorkspaceMutation, { data, loading, error }] = useRemoveAllTagsFromWorkspaceMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useRemoveAllTagsFromWorkspaceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveAllTagsFromWorkspaceMutation, RemoveAllTagsFromWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveAllTagsFromWorkspaceMutation, RemoveAllTagsFromWorkspaceMutationVariables>(RemoveAllTagsFromWorkspaceDocument, options);
      }
export type RemoveAllTagsFromWorkspaceMutationHookResult = ReturnType<typeof useRemoveAllTagsFromWorkspaceMutation>;
export type RemoveAllTagsFromWorkspaceMutationResult = Apollo.MutationResult<RemoveAllTagsFromWorkspaceMutation>;
export type RemoveAllTagsFromWorkspaceMutationOptions = Apollo.BaseMutationOptions<RemoveAllTagsFromWorkspaceMutation, RemoveAllTagsFromWorkspaceMutationVariables>;